<script setup>
import { onMounted, onBeforeMount, ref } from 'vue'
import { useFavoriteBrandsStore } from '@/store/favoriteBrands'
import { useFavoriteShopsStore } from '@/store/favoriteShops'
import Header from '@/Shared/Header/Header'
import Footer from '@/Shared/Footer/Footer'
import FlashMessages from '@/Shared/FlashMessages'
import { getCookie, hasTouchScreen } from '@/Shared/helper.js'

const props = defineProps({ pref: Object })

const htmlRef = ref()

onMounted(() => {
  htmlRef.value = document.getElementsByTagName('html')[0]
  const isTouch = hasTouchScreen() ? 'touch' : 'no-touch'
  htmlRef.value.classList.add(isTouch)
})

onBeforeMount(() => {
  const storeFavoriteBrands = useFavoriteBrandsStore()
  const storeFavoriteShops = useFavoriteShopsStore()
  if (getCookie('af_favorite_brands')) {
    storeFavoriteBrands.updateList(getCookie('af_favorite_brands'))
  } else {
    storeFavoriteBrands.updateList([])
  }
  if (getCookie('af_favorite_shops')) {
    storeFavoriteShops.updateList(getCookie('af_favorite_shops'))
  } else {
    storeFavoriteShops.updateList([])
  }
})
</script>

<template>
  <Header />
  <div class="main-body">
    <flash-messages :news="props.pref.stickynews" />
    <slot />
    <Footer />
  </div>
</template>
